import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {callAction} from 'client/framework';
import supplementEditorActions from 'client/Supplements/SupplementEditor/SupplementEditor.actions';
import TextInput from 'client/generic/Forms/TextInput/TextInput.react';
import TextArea from 'client/generic/Forms/TextArea/TextArea.react';
import Checkbox from 'client/generic/Forms/Checkbox/Checkbox.react';
import MarkdownRendererV2 from 'generic/MarkdownRendererV2/MarkdownRendererV2.react';
import {AuthoringSupplement as AuthoringSupplementModelV1} from 'resources/GeneratedModels/AuthoringSupplement/AuthoringSupplementModel.v1';
import './sortable-table-editor.scss';

export default class SortableTableEditor extends React.Component {
  static propTypes = {
    supplement: PropTypes.instanceOf(AuthoringSupplementModelV1),
    onChange: PropTypes.func,
    onCheckChange: PropTypes.func,
    errors: ImmutablePropTypes.map
  };

  UNSAFE_componentWillMount() {
    const hasTotal = this.props.supplement.getContent().get('hasTotal', false);
    callAction(supplementEditorActions.MODIFY_ACTIVE_SUPPLEMENT, {
      setter: 'setHasTotal',
      value: hasTotal
    });
  }

  render() {
    const errors = this.props.errors;
    const supplement = this.props.supplement;
    const hasTotal = supplement.getHasTotal();
    return (
      <div className='sortable-table-editor'>
        <div className='sortable-table-editor__fieldset'>
          <TextInput
            className='sortable-table-editor__input'
            data-setter-method='setName'
            error={Boolean(errors.get('name'))}
            errorMessage={errors.get('name', null)}
            label='Name'
            name='name'
            onChange={this.props.onChange}
            value={supplement.getName()}
          />
          <TextArea
            className='sortable-table-editor__input sortable-table-editor__input--textarea'
            data-setter-method='setText'
            error={Boolean(errors.get('text'))}
            errorMessage={errors.get('text', null)}
            label='Text'
            name='text'
            onChange={this.props.onChange}
            value={supplement.getText()}
          />
          <Checkbox
            className='sortable-table-editor__input sortable-table-editor__input--checkbox'
            checked={hasTotal}
            data-setter-method='setHasTotal'
            label='Include a TOTAL row'
            name='hasTotal'
            onChange={this.props.onCheckChange}
          />
        </div>
        <div className='sortable-table-editor-preview__wrapper'>
          <div className='a-form-input__label'>Preview</div>
          <MarkdownRendererV2
            className='sortable-table-editor__markdown-renderer'
            text={supplement.getText()}
          />
        </div>
      </div>
    );
  }
}
